import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import {
  NoItemsLeftInTable,
  convertTo12HourFormat,
  handleDateSetUp,
} from "../../../../helpers/helpers";
import { useDispatch, useSelector } from "react-redux";
import { getInspectionRequestForSeller } from "../../../../redux/action/inspectionRequest";
import LoadingSkeleton from "../../../loader/TableLoader";
import { Modal } from "react-materialize";
import InspectionModal from "../children/InspectionModal";
import Paginations from "../../../commanPage/pagination/Paginations";

function InspectionTable({ searchList }) {
  const dispatch = useDispatch();
  const totalNumberRow = 30;
  const isTablet = useMediaQuery({ query: "(max-width: 990px)" });
  const [inspectionData, setInspectionData] = useState([]);
  const [filterInspection, setFilterInspection] = useState([]);
  const [personalDetails, setPersonalDetails] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [maxPageVisited, setMaxPageVisited] = useState(1);
  const { loadings, sellerInspection } = useSelector(
    (state) => state?.inspectionForSeller
  );

  useEffect(() => {
    dispatch(getInspectionRequestForSeller(currentPage, totalNumberRow));
  }, [dispatch, currentPage, totalNumberRow]);

  useEffect(() => {
    if (sellerInspection) {
      setInspectionData(sellerInspection);
      setFilterInspection(sellerInspection);
    }
  }, [searchList, sellerInspection]);

  const viewDetailsFunctionality = (items) => {
    setPersonalDetails(items);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    const searchLower = searchList?.toLowerCase()?.trim();
    if (!searchLower) {
      setInspectionData([...filterInspection]);
    } else {
      const filteredDetails = filterInspection?.filter((item) =>
        ["auctionId", "industry", "inspectionBy", "auctionSchedule"].some(
          (field) => {
            if (field === "auctionSchedule") {
              return ["startDate", "startingTime", "endingTime"].some(
                (subField) => {
                  const fieldValue = item?.auction?.auctionSchedule?.[subField];
                  if (!fieldValue) return false;
                  if (
                    subField === "startingTime" ||
                    subField === "endingTime"
                  ) {
                    return convertTo12HourFormat(
                      new Date(fieldValue).toLocaleTimeString()
                    )
                      .toLowerCase()
                      .includes(searchLower);
                  }
                  return fieldValue?.toLowerCase()?.includes(searchLower);
                }
              );
            } else if (field === "industry") {
              const industry = item.industry?.organizationName?.toLowerCase();
              return industry?.includes(searchLower);
            } else if (field === "auctionId") {
              const fieldValue = item.auction?.[field];
              return fieldValue?.toLowerCase()?.includes(searchLower);
            } else {
              const fieldValue = item?.[field];
              return fieldValue?.toLowerCase()?.includes(searchLower);
            }
          }
        )
      );

      setInspectionData(filteredDetails);
    }
  }, [searchList, filterInspection]);

  return (
    <>
      {loadings ? (
        <div className="valign-wrapper justify-center cover white">
          <LoadingSkeleton
            headerData={[
              "Auction ID",
              "Date & Time",
              "Inspected by",
              "Inspection date",
              "No.of Peoples",
              "Status",
              "Actions",
            ]}
          />
        </div>
      ) : (
        <>
          <div className="table-container-style mt-1">
            <table
              className={`responsive-table centered ${
                isTablet ? "auction_table table-style" : "custom-table-style"
              } `}
            >
              <thead>
                <tr>
                  <th>Auction Id</th>
                  <th>Date & Time</th>
                  <th>Inspected by</th>
                  <th>Inspection date</th>
                  <th>No.of Peoples</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {inspectionData?.map((items, index) => (
                  <tr key={items?.auctionId}>
                    <td>{items?.auction?.auctionId}</td>
                    <td>{`${handleDateSetUp(
                      items?.auction?.auctionSchedule?.startDate
                    )} & ${convertTo12HourFormat(
                      items?.auction?.auctionSchedule?.startingTime
                    )}`}</td>

                    <td>{items?.inspectionBy}</td>
                    <td>{handleDateSetUp(items?.inspectionDate)}</td>
                    <td>{items?.numberOfPeople}</td>
                    <td
                      style={{
                        color:
                          items?.status === "approved" ? "#4EAB33" : "#F44336",
                      }}
                    >
                      {items.status === "approved" ? "Visited" : "Not visited"}
                    </td>
                    <td>
                      <button
                        className="text-decoration-underLine cercle-purple-text bold"
                        disabled={items?.status === "pending"}
                        style={{
                          opacity: items.status === "pending" && "0.3",
                        }}
                        onClick={() => viewDetailsFunctionality(items)}
                      >
                        View Response
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {inspectionData?.length <= 0 && <NoItemsLeftInTable />}
          </div>
          <Paginations
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalNumberRow={totalNumberRow}
            totalData={inspectionData?.length}
            maxPageVisited={maxPageVisited}
            setMaxPageVisited={setMaxPageVisited}
          />
        </>
      )}
      <Modal
        actions={[]}
        bottomSheet={false}
        fixedFooter={false}
        className="modelAccount"
        id="modalView-details"
        open={isModalOpen}
        options={{
          onCloseEnd: closeModal,
        }}
      >
        <InspectionModal personalDetails={personalDetails} />
      </Modal>
    </>
  );
}

export default InspectionTable;
